import { render, staticRenderFns } from "./NationalTrademarkTransactionReport.vue?vue&type=template&id=3190ee39&"
import script from "./NationalTrademarkTransactionReport.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkTransactionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports